export const READ_ONLY_PREVIEW_KEY = 'readOnlyPreview';
export const PREVIEW_SCOPED_STORAGE_KEYS = [
  'progress',
  'initialVideo',
  'bagOfTricks',
];

const getLocalStorage = () =>
  typeof window === 'undefined' ? null : window.localStorage;

const getSessionStorage = () =>
  typeof window === 'undefined' ? null : window.sessionStorage;

export const isReadOnlyPreviewEnabled = () =>
  getSessionStorage()?.getItem(READ_ONLY_PREVIEW_KEY) === 'true' ||
  getLocalStorage()?.getItem(READ_ONLY_PREVIEW_KEY) === 'true';

export const setReadOnlyPreviewEnabled = (enabled) => {
  const sessionStorage = getSessionStorage();
  const localStorage = getLocalStorage();

  if (enabled) {
    sessionStorage?.setItem(READ_ONLY_PREVIEW_KEY, 'true');
    localStorage?.removeItem(READ_ONLY_PREVIEW_KEY);
    return;
  }

  sessionStorage?.removeItem(READ_ONLY_PREVIEW_KEY);
  localStorage?.removeItem(READ_ONLY_PREVIEW_KEY);
};

const getPreviewScopedStorage = () =>
  isReadOnlyPreviewEnabled() ? getSessionStorage() : getLocalStorage();

export const getPreviewScopedItem = (key) =>
  getPreviewScopedStorage()?.getItem(key);

export const setPreviewScopedItem = (key, value) => {
  getPreviewScopedStorage()?.setItem(key, value);
};

export const clearReadOnlyPreviewData = () => {
  const sessionStorage = getSessionStorage();

  setReadOnlyPreviewEnabled(false);
  PREVIEW_SCOPED_STORAGE_KEYS.forEach((key) =>
    sessionStorage?.removeItem(key),
  );
};
